import React from 'react';
import { useState, useEffect, useRef } from "react";
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import '../../assets/Styles/CommonComponentCSS/Toast.css'; // Import Bootstrap CSS

function ToastControl(props = {}) {
    let state = {
        Title: "",
        Body: "",
        animation: false,
        AutoHide: 0, //0 means disable auto hidding, any other values means auto hide time in millisecs.
        bg: "info",//'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light'
        position:"top-center",//'top-start' | 'top-center' | 'top-end' | 'middle-start' | 'middle-center' | 'middle-end' | 'bottom-start' | 'bottom-center' | 'bottom-end'
        ShowLoader: false,
        ShowSecondsPassed: true,
        Styles: { zIndex: 99999999 }

    };
    state = {...state, ...props.options};
    const [show, setShow] = useState(true);
    const [autoHide, setautoHide] = useState(state.AutoHide !== 0);
    const [delay, setdelay] = useState(state.AutoHide !== 0 ? state.AutoHide : undefined);
    const [Position, setPosition] = useState(state.position);
    const [Animation, setAnimation] = useState(state.animation);
    const [bg, setbg] = useState(state.bg);
    const [Body, setBody] = useState(state.Body);
    const [Title, setTitle] = useState(state.Title);
    const [ShowLoader, setShowLoader] = useState(state.ShowLoader);
    const [HeaderSmallText, setHeaderSmallText] = useState("");
    const intervalRef = useRef(null);
    const [seconds, setSeconds] = useState(0);
    const [OptsStyles, setOptsStyles] = useState(state.Styles);

    useEffect(() => {
        state = {...state, ...props.options};
        setautoHide(state.AutoHide !== 0);
        setdelay(state.AutoHide !== 0 ? state.AutoHide : undefined);
        setPosition(state.position);
        setAnimation(state.animation);
        setbg(state.bg);
        setBody(state.Body);
        setTitle(state.Title);
        setShow(state.ShowToast);
        setShowLoader(state.ShowLoader);
        setSeconds(0);
        setOptsStyles(state.Styles);
    }, [props.options]);

    useEffect(()=>{
        if(state.ShowSecondsPassed){
            intervalRef.current = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds + 1);
                }, 1000);
        }
            // Cleanup function to stop the timer when the component unmounts
        return () => {
            try{
                clearInterval(intervalRef.current);
                setSeconds(0);
                setHeaderSmallText("");
            }
            catch (e) { }
        };
    }, []);
    useEffect(() => {
        if(state.ShowSecondsPassed){
            setHeaderSmallText(seconds.toString() + " seconds ago");
        }
        else{
            setHeaderSmallText("");
        }
    }, [seconds]);

    function onClose(e) {
        setShow(false);
        try{
            clearInterval(intervalRef.current);
            setSeconds(0);
            setHeaderSmallText("");
        }
        catch (e) { }
        try{
            if (typeof props.onClose === 'function') {
                props.onClose();
            }
        }
        catch(e){
            console.error(e);
        }
    }
    function onEnter(e) {
        
    }
    function onEntering(e) {
        
    }
    function onEntered(e) {
        
    }
    return (
        <>
        <ToastContainer position={Position} className="p-3" style={OptsStyles}>
            <Toast animation={Animation} bg={bg} autohide={autoHide} delay={delay} show={show} onClose={onClose}  style={{ width: '400px' }}>
                {(Title !== "") && 
                <Toast.Header>
                    <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
                    <strong className="me-auto">{Title}</strong>
                    <small>{HeaderSmallText}</small>
                </Toast.Header>
                }
                <Toast.Body>{ShowLoader && <div className='loaderToast' id ='temp'></div>}{Body}</Toast.Body>
            </Toast>
        </ToastContainer>
        </>
  );
}

export default ToastControl;